import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface CabinetsAndCountertopsDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const CabinetsAndCountertopsDescription: React.FC<CabinetsAndCountertopsDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [cabinetsAndCountertops, set_cabinetsAndCountertops] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Cabinets and Countertops']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Cabinets and Countertops': [v, b.values?.['Interior']?.['Cabinets and Countertops']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={cabinetsAndCountertops}
                />
            ) : (
                <TextBox
                    value={cabinetsAndCountertops}
                    onChange={(value) => set_cabinetsAndCountertops(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
